import { setOrRemoveAttributes } from '../utilities.js';

//=====================================================================
// Menu button events and functions
//=====================================================================

export const menuButtonEvents = (headerFunctions, body, menu) => {
    const buttonMenuOpen = headerFunctions.querySelector('[data-menuButton]');
    const buttonMenuSearchOpen = headerFunctions.querySelector('[data-searchButton]');
    const menuBodyOverlay = headerFunctions.querySelector('[data-menuBodyOverlay]');


    const activateMenu = () => {
        const isMenuOpen = body.classList.toggle('-mobileMenuIsOpen');
        setOrRemoveAttributes(buttonMenuOpen, { 'aria-expanded': isMenuOpen }, [ 'aria-label' ]);
        setOrRemoveAttributes(menu, { 'aria-hidden': 'Close menu', 'aria-expanded': !isMenuOpen });
        setOrRemoveAttributes(menuBodyOverlay, { 'aria-label': 'Close menu', 'aria-expanded': isMenuOpen });

        if (isMenuOpen) menuBodyOverlay.addEventListener('click', menuBodyOverlayEvents)
    }

    // Open the menu and add the event listener to the overlay
    buttonMenuOpen.addEventListener('click', () => {
        activateMenu();
    });

    // Active focus on the searh on Freetype search
    buttonMenuSearchOpen.addEventListener('click', () => {
        activateMenu();
        const freetypeSearch = headerFunctions.querySelector('input.ais-SearchBox-input');
        if (!freetypeSearch) return;
        freetypeSearch.focus();
    });
    
    function menuBodyOverlayEvents() {
        body.classList.toggle('-mobileMenuIsOpen');
        
        setOrRemoveAttributes(buttonMenuOpen, { 'aria-expanded': 'false', 'aria-label': 'Open menu' });
        menu.setAttribute('aria-hidden', 'true');
        setOrRemoveAttributes(menuBodyOverlay, { 'aria-expanded': 'false' }, ['aria-label']);
        
        setOrRemoveAttributes(menuBodyOverlay, { 'aria-expanded': 'false' }, []);
        // Remove the event listener
        menuBodyOverlay.removeEventListener('click', menuBodyOverlayEvents)
    } 
}